import { call, put, takeLatest } from "redux-saga/effects";
import {
  submitLeadForm,
  submitLeadFormSuccess,
  submitLeadFormFailure,
} from "../slices/leadSlice";

const API_URL = process.env.REACT_APP_API_URL;

const postLeadFormAPI = async (leadData) => {
  const res = await fetch(`${API_URL}/v1/leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(leadData),
  });

  const result = await res.json();
  if (!res.ok) {
    // If backend returns validation errors
    if (result.errors) {
      throw { message: result.message || "Validation failed", errors: result.errors };
    }
    throw new Error(result.message || "Submission failed");
  }
  return result;
};

function* handleSubmitLeadForm(action) {
  try {
    yield call(postLeadFormAPI, action.payload);
    yield put(submitLeadFormSuccess());
  } catch (error) {
    // Pass both message and errors object
    yield put(submitLeadFormFailure({
      message: error.message || "Submission failed",
      errors: error.errors || null
    }));
  }
}

export function* watchLeadSaga() {
  yield takeLatest(submitLeadForm.type, handleSubmitLeadForm);
}
